import logo from "../../assets/images/logo_klhk.png";
import RootAuth from "../../components/layouts/RootAuth";
import { ArrowLeftIcon, EnvelopeIcon, EyeIcon, EyeSlashIcon, LockClosedIcon } from "@heroicons/react/24/outline";
import { Button, Checkbox, Input, Modal, ModalBody, ModalContent, ModalHeader, TableCell, TableRow } from "@nextui-org/react";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { getFetcher, getFetcherPublic, login } from "../../services/api";
import Cookies from "js-cookie";
import {
  CMS_NEWS_PATH,
  DASHBOARD_PATH,
  FORGOT_PASSWORD_PATH,
  NOTIFICATION_DASHBOARD_PATH,
  PELAPORAN_DASHBOARD_PATH,
  RECOMENDATION_DASHBOARD_PATH,
  REGISTER_PATH,
  REGISTER_PTSP_PATH,
  REGISTRATION_DASHBOARD_PATH,
  USERS_MANAGEMENT_INDEX_PATH,
  KOORDINATOR_DASHBOARD_PATH,
  ROOT_PATH,
} from "../../services/routes";
import { isResponseErrorObject } from "../../services/helpers";
import RolesAccess from "../../enums/roles";
import ClientTablePagination from "../../components/elements/ClientTablePagination";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-hot-toast";

export default function LoginPage() {
  const [isVisible, setIsVisible] = useState(false);
  const [loginError, setLoginError] = useState(""); // State untuk error message
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState("");

  const [modalVisible, setModalVisible] = useState(false); // Untuk mengontrol visibilitas modal
  const [permohonan, setPermohonan] = useState([]); // Data bahan kimia
  const [isOpenModalForm, setIsOpenModalForm] = useState(false);
  const handleSearch = async () => {
    if (searchValue === null || searchValue?.trim() === "") {
      toast.error("Pencarian tidak boleh kosong");
    }
    try {
      const result = await getFetcherPublic(`/api/auth/monitor-register?kode=${searchValue}`);

      setPermohonan([result]);
    } catch (error) {
      if (isResponseErrorObject(error?.response?.data?.message)) {
        const firstError = Object.values(error?.response?.data?.message)[0];
        toast.error(firstError);
      } else {
        toast.error(error?.response?.data?.message || "Monitor Registrasi gagal. Silakan coba lagi.");
      }
      setPermohonan([]);
    }
  };

  const header = ["Kode Permohonan", "Email", "Nama Perusahaan", "Status"];
  const content = (item) => (
    <TableRow key={item?.id ?? uuidv4()}>
      <TableCell>{item?.kodePermohonan ?? ""}</TableCell>
      <TableCell>{item?.user?.email ?? ""}</TableCell>
      <TableCell>{item?.company?.name ?? ""}</TableCell>
      <TableCell>{!item?.isApproved ? "Dalam Review" : "Sudah Approved Silahkan Login"}</TableCell>
    </TableRow>
  );

  function toggleVisibility() {
    setIsVisible(!isVisible);
  }

  async function onSubmit(data) {
    setLoginError(""); // Reset error sebelum submit
    try {
      data.expiresInMins = 1;
      data.clientId = process.env.REACT_APP_CLIENT_ID;
      data.clientSecret = process.env.REACT_APP_CLIENT_SECRET;

      const response = await login(data);

      if (!response.data?.accessToken) {
        setLoginError("Login gagal. Silakan coba lagi.");
        return;
      }

      // Set cookies untuk token
      Cookies.set("accessToken", response.data?.accessToken, { expires: 0.5, secure: true, sameSite: "strict" });
      Cookies.set("refreshToken", response.data?.refreshToken, { expires: 0.5, secure: true, sameSite: "strict" });
      Cookies.set("sessionExpired", response.data?.sessionExpired, { expires: 0.5, secure: true, sameSite: "strict" });

      // Decode token untuk mendapatkan roles
      const base64Url = response.data?.accessToken.split(".")[1];
      const base64 = base64Url.replace("-", "+").replace("_", "/");
      const userdata = JSON.parse(window.atob(base64));
      const userInfo = await getFetcher(`/api/users/find/${userdata.userId}`);
      const roles = userInfo.roles.map((role) => role.role.name); // Asumsikan ini adalah array roles

      const rolePaths = {
        [RolesAccess.PIC_PELAPORAN]: PELAPORAN_DASHBOARD_PATH,
        [RolesAccess.PENGELOLA]: PELAPORAN_DASHBOARD_PATH,
        [RolesAccess.PIC_CMS]: CMS_NEWS_PATH,
        [RolesAccess.PIC_NOTIFIKASI]: NOTIFICATION_DASHBOARD_PATH,
        [RolesAccess.PIC_REGISTRASI]: REGISTRATION_DASHBOARD_PATH,
        [RolesAccess.PIC_REKOMENDASI]: RECOMENDATION_DASHBOARD_PATH,
        [RolesAccess.PIC_USER]: USERS_MANAGEMENT_INDEX_PATH,
        [RolesAccess.KOORDINATOR]: KOORDINATOR_DASHBOARD_PATH,
        ...Object.fromEntries([RolesAccess.SUPER_ADMIN, RolesAccess.DIREKTUR, RolesAccess.KAB_SUBDIT_REGISTRASI, RolesAccess.KAB_SUBDIT_REKOMENDASI].map((role) => [role, DASHBOARD_PATH])),
      };
      // Cari role pengguna untuk redirect
      const userRole = roles.find((role) => rolePaths[role]);
      if (userRole) {
        navigate(rolePaths[userRole], { replace: true });
      } else {
        setLoginError("Role tidak ditemukan. Hubungi administrator.");
      }
    } catch (error) {
      if (isResponseErrorObject(error?.response?.data?.message)) {
        const firstError = Object.values(error?.response?.data?.message)[0];
        setLoginError(firstError);
      } else {
        setLoginError(error?.response?.data?.message || "Login gagal. Silakan coba lagi.");
      }
    }
  }

  const openModalForm = async (item = null) => {
    setIsOpenModalForm(true);
  };

  const handleSimpelLogin = () => {
    const simpelUrl = process.env.REACT_APP_AKUN_SIMPEL_URL;
    const simpelAppKey = process.env.REACT_APP_SIMPEL_APP_KEY;
    const redirectRoute = "simpel/login";

    // Construct SIMPEL login URL
    const simpelLoginUrl = `${simpelUrl}/login/app/?_continue=${redirectRoute}&_key=${simpelAppKey}`;

    // Redirect to SIMPEL
    window.location.href = simpelLoginUrl;
  };

  return (
    <RootAuth>
      <div className="relative w-full flex flex-col p-5 md:p-24 m-5 lg:m-0 bg-white shadow-md lg:shadow-none rounded-xl lg:rounded-none">
        <div className="text-center lg:text-start pb-7">
          {/* Logo beserta identitas kementerian di sebelahnya jadi satu tombol
              menuju beranda - susunannya sama dengan bilah atas situs publik,
              supaya halaman masuk tidak terasa terputus dari situsnya.

              Halaman ini tidak punya bilah menu sama sekali, jadi masih ada
              tautan "Kembali ke Beranda" yang tersurat di bagian paling bawah:
              tidak semua orang menduga logo bisa diklik. */}
          <button
            type="button"
            onClick={() => navigate(ROOT_PATH)}
            aria-label="Kembali ke beranda"
            className="flex items-center gap-3 mx-auto lg:mx-0 text-left cursor-pointer bg-transparent border-0 p-0"
          >
            <img src={logo} alt="Logo Kementerian Lingkungan Hidup" className="size-20 shrink-0" />
            <span className="block">
              <span className="block text-ink-700 font-semibold text-base leading-tight">Direktorat Pengelolaan B3</span>
              <span className="block text-ink-500 font-medium text-xs leading-snug">
                Kementerian Lingkungan Hidup / Badan Pengendali Lingkungan Hidup
              </span>
            </span>
          </button>


          <h3 className="font-bold text-2xl mt-5">Masukan Akun Anda</h3>
          <p className="text-base">Sistem Informasi Tata Kelola dan Perizinan Bahan Berbahaya dan Beracun</p>
        </div>
        <form className="pt-3 font-medium" onSubmit={handleSubmit(onSubmit)}>
          <Input
            {...register("email", { required: "Email is required" })}
            radius="sm"
            className="pb-5"
            type="text"
            size="lg"
            color={errors.email ? "danger" : "default"}
            placeholder="Email"
            startContent={<EnvelopeIcon className="size-5" />}
            isInvalid={errors.email}
            errorMessage={errors.email && errors.email.message}
          />
          <Input
            {...register("password", { required: "Password is required" })}
            radius="sm"
            className="pb-5"
            type={isVisible ? "text" : "password"}
            size="lg"
            color={errors.password ? "danger" : "default"}
            placeholder="Password"
            startContent={<LockClosedIcon className="size-5" />}
            endContent={
              <Button isIconOnly onClick={toggleVisibility}>
                {isVisible ? <EyeSlashIcon className="size-5" /> : <EyeIcon className="size-5" />}
              </Button>
            }
            isInvalid={errors.password}
            errorMessage={errors.password && errors.password.message}
          />

          <div className="flex items-center justify-between pb-10">
            <Checkbox {...register("remember")} radius="sm" size="md">
              Ingat Saya
            </Checkbox>
            <Link to={FORGOT_PASSWORD_PATH} className="hover:underline">
              Lupa Password?
            </Link>
          </div>

          <Button isLoading={isSubmitting} isDisabled={isSubmitting} type="submit" radius="sm" color="primary" className="w-full text-lg py-5">
            Masuk
          </Button>

          {/* Menampilkan pesan error login */}
          {loginError && <p className="text-danger mt-3 text-center">{loginError}</p>}
        </form>

        <div className="mt-4 flex items-center gap-1 justify-center">
          <span className="text-center">Akun dari SIMPEL?</span>
          <div onClick={() => handleSimpelLogin()} className="text-primary hover:underline cursor-pointer">
            Masuk Disini
          </div>
        </div>

        {/* Jalan pulang ditaruh paling bawah: yang datang ke sini tujuannya masuk,
            jadi tautan keluar tidak perlu menyela urutan baca menuju formulir. */}
        <div className="mt-6 flex justify-center">
          <Link to={ROOT_PATH} className="inline-flex items-center gap-1 text-sm text-primary hover:underline">
            <ArrowLeftIcon className="size-4" />
            Kembali ke Beranda
          </Link>
        </div>

        {/* <div className="mt-4 flex items-center gap-1 justify-center">
          <span className="text-center">Cek Status Registrasi?</span>
          <div onClick={() => openModalForm()} className="text-primary hover:underline cursor-pointer">
            Lihat Disini
          </div>
        </div>

        <div className="mt-3 flex items-center gap-1 justify-center">
          <span className="text-center">Akun Dari PTSP?</span>
          <Link to={REGISTER_PTSP_PATH} className="text-primary hover:underline">
            Daftar Disini
          </Link>
        </div>
        <div className="mt-3 flex items-center gap-1 justify-center">
          <span className="text-center">Belum Punya Akun?</span>
          <Link to={REGISTER_PATH} className="text-primary hover:underline">
            Daftar Disini
          </Link>
        </div> */}
        <Modal size="3xl" isOpen={isOpenModalForm} onOpenChange={setIsOpenModalForm} onClose={() => setModalVisible(false)} styles={"z-100"}>
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader>Monitor Registrasi</ModalHeader>
                <ModalBody className={"flex flex-col gap-4"}>
                  {/* Search Input */}
                  <div className="flex items-center gap-3">
                    <Input placeholder="Masukkan kodepermohonan atau email pendaftar" className="w-full" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} clearable />
                    <Button color="primary" onClick={handleSearch}>
                      Cari
                    </Button>
                  </div>

                  {/* Tabel Pagination */}
                  <div className="flex w-full justify-center">
                    <ClientTablePagination header={header} data={permohonan} content={content} />
                  </div>
                </ModalBody>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    </RootAuth>
  );
}
